import { render, staticRenderFns } from "./ContentSettings.vue?vue&type=template&id=66eb2d66&scoped=true"
import script from "./ContentSettings.vue?vue&type=script&lang=js"
export * from "./ContentSettings.vue?vue&type=script&lang=js"
import style0 from "./ContentSettings.vue?vue&type=style&index=0&id=66eb2d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb2d66",
  null
  
)

export default component.exports